import React, { useEffect, useState } from "react";
import { Theme } from "../../types/theme";
import { Loader2 } from "lucide-react";
import { BookingDetails } from "./BookingForm";

interface ConfirmationCardProps {
  theme: Theme;
  isLoading: boolean;
  onSubmit: (otp: string) => void;
  resendOTP: (bookingDetails: BookingDetails) => void;
  bookingDetails: BookingDetails;
}

export const ConfirmationCard: React.FC<ConfirmationCardProps> = ({
  theme,
  isLoading,
  onSubmit,
  resendOTP,
  bookingDetails,
}) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);

  // TIMER EFFECT (Counts Down From 30s)
  useEffect(() => {
    if (timer === 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleResend = () => {
    setTimer(30);
    resendOTP(bookingDetails);
  };

  return (
    <div
      className="rounded-xl p-6 max-w-md shadow-lg border"
      style={{ backgroundColor: theme.backgroundColor, borderColor: theme.borderColor }}
    >
      <div
        className="p-1 text-center mb-1"
      >
        <p className="text-green-700 text-sm font-medium">OTP sent to your email.</p>
      </div>

      <input
        type="text"
        maxLength={6}
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        className="w-full p-2 rounded-md border font-medium text-center tracking-widest text-lg outline-none focus:ring-2 transition"
        style={{
          borderColor: theme.borderColor,
          backgroundColor: theme.surfaceColor,
          color: theme.textColor,
        }}
        placeholder="Enter OTP"
      />

      {/* VERIFY BUTTON */}
      <button
        disabled={otp.length !== 6 || isLoading}
        onClick={() => onSubmit(otp)}
        className="mt-4 w-full p-2 flex items-center justify-center text-white rounded-md font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 transition-opacity"
        style={{ backgroundColor: theme.primaryColor }}
      >
        {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Verify OTP"}
      </button>

      {/* RESEND SECTION */}
      <div className="mt-4 text-center">
        {timer > 0 ? (
          <p className="text-sm opacity-70" style={{ color: theme.textColor }}>
            Resend OTP in <span className="font-semibold">{timer}s</span>
          </p>
        ) : (
          <button
            onClick={handleResend}
            disabled={isLoading}
            className="text-sm font-medium hover:underline transition disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ color: theme.primaryColor, background: "transparent" }}
          >
            Resend OTP
          </button>
        )}
      </div>
    </div>
  );
};
